import { Environment } from '@wheere-front/inside-shared-util';

export const environment: Environment = {
  production: true,
  type: 'develop',
  url: 'https://inside.dev.wheere.tech',
  customerUrl: 'https://customer.dev.wheere.tech',
  api: {
    tracker: 'https://inside.dev.wheere.tech/api/tracker',
    notification: 'https://inside.dev.wheere.tech/api/notification',
    gateway: 'https://inside.dev.wheere.tech/api/gateway',
    site: 'https://inside.dev.wheere.tech/api/site',
    websocket: 'https://inside.dev.wheere.tech/api',
    user: 'https://users.dev.wheere.tech/api',
  },
  keycloak: {
    issuer: 'https://auth.dev.wheere.tech',
    realm: 'wheere',
    clientId: 'frontend',
  },
  maptiles: 'D9ZvuUNhUV4ar033H5oD',
};
